import { useEffect, useState } from 'react';

export const GSI_SCRIPT_SRC = 'https://accounts.google.com/gsi/client';

// One script load per page, shared by every caller.
let scriptPromise = null;

export function loadGoogleIdentityScript() {
  if (window.google?.accounts?.id) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = GSI_SCRIPT_SRC;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => {
        scriptPromise = null; // allow a retry on the next mount
        reject(new Error('Could not load Google sign-in.'));
      };
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

/**
 * Loads Google Identity Services once a client ID is known (from
 * useLoginOptions). Returns { ready }: true once window.google.accounts.id
 * is usable. A null clientId loads nothing.
 */
export function useGoogleSignIn(clientId) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!clientId) return undefined;
    let cancelled = false;
    loadGoogleIdentityScript()
      .then(() => {
        if (!cancelled) setReady(true);
      })
      .catch((error) => {
        console.warn('Google sign-in unavailable:', error.message);
      });
    return () => {
      cancelled = true;
    };
  }, [clientId]);

  return { ready };
}

export default useGoogleSignIn;
